// extracted by mini-css-extract-plugin
export default {"content":"NoMatch_content__Mw7DD","mainText":"NoMatch_mainText__n0IrA","image":"NoMatch_image__Zogd0"};